import React, { Component } from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { GridTable } from '../common/Table/Table';
import { applyFilterOnData, IsSectionVisible, removeDuplicates, UpdateColumnWithConfiguration } from '../../utils/helper';
import { clientColumns, transitionColumns } from '../../constants/MockData';
import { Operators, SECTIONS } from '../../constants/appConstants';
import { IconButton, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { Visibility } from '@material-ui/icons';
import { controlType } from '../../constants/common';
import _ from 'lodash';
import AddEditClient from './AddEditClient';

export class Client extends Component {
  constructor () {
    super();
    this.state = {
      clientMasterData: [],
      selectedData: [],
      responseClientMasterData: [],
      isInEditMode: false,
      isInViewMode: false,
      responseAllMarketStateData: []
    };
  }

  componentDidMount () {
    this.LoadData();
  }

  onViewChange = () => {
    this.setState({
      isInEditMode: false,
      isInViewMode: false,
      selectedData: []
    }, () => this.LoadData());
  }

  onFilterChange = (selectedData) => {
    const { responseClientMasterData } = this.state;
    const filteredData = applyFilterOnData(_.cloneDeep([...responseClientMasterData]), selectedData);
    const address = selectedData?.find(x => x.key === 'address')?.selected[0]?.address;
    const email = selectedData?.find(x => x.key === 'email')?.selected[0]?.email;
    let one = selectedData;
    if (address === '') {
      one = selectedData.filter(x => x.key !== 'address');
    }

    if (email === '') {
      one = selectedData.filter(x => x.key !== 'email');
    }
    // console.log(one);
    this.setState({ clientMasterData: filteredData, selectedData: one });
  };

  LoadData () {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Transition.GetAllClient,
        key: 'clientMasterData'
      },
      {
        url: `${API_URL.Market.GetMarketCityStateMasterData}?stateId=${-1}`,
        key: 'allMarketStateData'
      }

    ])
      .then(
        ({
          clientMasterData,
          allMarketStateData
        }) => {
          this._asyncRequest = null;
          if (clientMasterData.success === true) {
            clientMasterData.data.forEach(x => {
              x.stateName = x.state;
            });
            this.setState({
              clientMasterData: clientMasterData.data || [],
              allMarketStateData: allMarketStateData.data || [],
              // clientListingMasterData: clientListingMasterData.data || [],
              responseClientMasterData: _.cloneDeep(clientMasterData.data || []),
              responseAllMarketStateData: _.cloneDeep(allMarketStateData.data || [])
            });

            // console.log(clientMasterData);
          } else {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  editClient = (id, row, isInViewMode) => {
    // console.log(id, row);
    this.setState({
      isInEditMode: true,
      clientId: id,
      clientDetails: row,
      isInViewMode: isInViewMode
    });
  }

  renderActionColumn = (row) => {
    const permission = IsSectionVisible(SECTIONS.CLIENTS, 0, SECTIONS.ADD_EDIT);
    return (
      <>
        {permission &&
          <Tooltip title="Edit">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.editClient(row.clientId, row, false);
              }}
            >
              <EditIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
        }
        {IsSectionVisible(SECTIONS.CLIENTS) && permission === false &&
          <Tooltip title="View">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.editClient(row.clientId, row, true);
              }}
            >
              <Visibility fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
        }
      </>
    );
  };

  render () {
    const { clientMasterData, responseClientMasterData, responseAllMarketStateData, selectedData, isInEditMode, clientId, clientDetails, isInViewMode } = this.state;
    return (
      <>
        {isInEditMode === true
          ? (<AddEditClient
            onViewChange={this.onViewChange}
            clientMasterData={clientMasterData}
            clientId={clientId}
            clientDetails={clientDetails}
            isInViewMode={isInViewMode}
          />
            )
          : <>
            <PageHeader title="Clients"></PageHeader>
            <PageFilter
              autoFilter={false}
              filterAlwaysVisible={true}
              onFilterChanged={this.onFilterChange}
              filterConfig={[
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: removeDuplicates(responseClientMasterData, 'name'),
                  key: 'name',
                  placeholder: 'Client Name',
                  title: 'Client Name'
                },
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: removeDuplicates(responseAllMarketStateData, 'stateName'),
                  key: 'stateName',
                  placeholder: 'State',
                  title: 'State'
                },
                {
                  multiple: false,
                  type: controlType.TextBox,
                  key: 'address',
                  title: 'Address',
                  operator: Operators.Like,
                  checkString: true,
                },
                {
                  multiple: false,
                  type: controlType.TextBox,
                  key: 'email',
                  title: 'Email',
                  operator: Operators.Like,
                  checkString: true,
                }
              ]}
              gridColumn={3}
              defaultSelectedData={[]}
              selectedData={selectedData}
            ></PageFilter>

            <div className="row table-list-container">
              <GridTable
                columns={UpdateColumnWithConfiguration(
                  clientColumns,
                  this.state.configuration
                )}
                // config={transitionListConfig}
                data={clientMasterData}
                renderActionColumn={this.renderActionColumn}
              // AddNewRecord={{
              //   action: () => {
              //     this.setState({ addEditView: true });
              //   },
              //   title: 'Add New Transition',
              //   visible: IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT),
              // }}
              ></GridTable>
            </div>
          </>}

      </>
    );
  }
}

export default Client;
